define('home/collections/SourceForumCollection',[
    'underscore',
    'core/api',
    'home/collections/ForumCollection',
], function (
    _,
    api,
    ForumCollection
) {
    'use strict';

    var SourceForumCollection = ForumCollection.extend({
        url: api.getURL('internal/channels/listSourceForums'),

        initialize: function (_models, options) {
            this.channelId = options && options.channelId;
        },

        fetch: function (options) {
            options = options || {};
            options.data = _.extend({
                channel: this.channelId,
                attach: 'counters',
            }, options.data);

            return ForumCollection.prototype.fetch.call(this, options);
        },
    });

    return SourceForumCollection;
});

